<template>
  <div class="overlay">
    <div class="overlay__inner">
      <div class="panel">
        <div class="panel__header">
          <h3 class="panel__title">{{ accountUserName }} Edit</h3>

          <span class="overlay__close" @click="done">
            <i class="fal fa-times"></i
            ></span>
        </div>
        <div class="panel__content">
          <div class="form-field">
            <div class="grid-x grid-padding-x">
              <div class="cell small-4">
                <label>Vendor Accounts</label>
              </div>
              <div class="cell auto">
                <div v-if="pushVendors.length > 0">
                  <div v-for="vendor in pushVendors" :key="vendor.id">{{
                      vendor.name
                    }}
                    <button class='button--small remove text-right'
                            @click="removeVendor(vendor.id)">x
                    </button>
                  </div>
                </div>
                <div v-else>
                  This Account Currently is not associated with any vendors
                </div>
              </div>
            </div>
          </div>

          <div class="form-field" style="position: relative; z-index: 2; ">
            <div class="grid-x grid-padding-x">
              <div class="cell small-4">
                <label>Add Vendor</label>
              </div>
              <div class="cell small-5">
                <div class="cell auto">
                  <div class="searchable-field">
                    <input id="vendor-override" name="vendor-override"
                           type="text"
                           placeholder="type 3 characters to search..."
                           v-on:input='searchVendors($event.target.value)'>

                    <div class="searchable-field__data"
                         v-if="searchedVendors.length > 0">

                      <div :id="row.id" class="searchable-field__option"
                           v-for="(row, key) in searchedVendors" :key="key"
                           @click="addVendor(row)">
                        {{ row.name }}
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-field" style="position: relative; z-index: 1;">
            <div class="grid-x grid-padding-x">
              <div class="cell small-4">
                <label>Active</label>
              </div>
              <div class="cell small-4">
                <checkbox @check="checkTest" :active="this.approval ? this.approval : false"></checkbox>
              </div>
            </div>
          </div>

          <div class="form-field" style="position: relative; z-index: 1;">
            <a @click="changePassword" v-html="changePasswordText"></a>
          </div>

          <div v-if="changingPassword">
            <div class="form-field">
              <label for="new-password">New Password</label>
              <input id="new-password" name="new-password" type="password">
            </div>

            <div class="form-field">
              <label for="confirm-new-password">Confirm New Password</label>
              <input id="confirm-new-password" name="confirm-new-password"
                     type="password">
            </div>

            <div class="text-success-color text-right"
                 v-if="passwordSuccess !== null" v-html="passwordSuccess"></div>

            <div class="text-alert-color text-right"
                 v-if="passwordError !== null" v-html="passwordError"></div>
          </div>

          <div class="panel__footer text-right">
            <div class="text-success-color text-right"
                 v-if="accountSuccess !== null" v-html="accountSuccess"></div>

            <div class="text-alert-color text-right"
                 v-if="accountError !== null" v-html="accountError"></div>

            <div class="grid-x">
              <div class="cell shrink">
                <div class="form-field" style="position: relative; z-index: 1;">
                  <button class="button--red" @click="deleteAccount">Delete Account</button>
                </div>
              </div>

              <div class="cell auto">
                <button class="button--alt" @click="done">Cancel</button>
                <button @click="saveVendors">Save</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'
import Checkbox from '@/globals/checkbox'

export default {
  components: {Checkbox},
  props: [
    'accountUserName',
    'accountVendorList',
    'accountID',
    'accountApproval'
  ],
  mixins: [client, utils],
  data: function () {
    return {
      changePasswordText: 'change password',
      vendorName: '',
      searchedVendors: [],
      pushVendors: [],
      approval: '',
      vendorIDs: [],
      id: '',
      isActive: false,
      changingPassword: false,
      passwordSuccess: null,
      passwordError: null,
      accountSuccess: null,
      accountError: null
    }
  },
  methods: {
    changePassword () {
      this.changingPassword = !this.changingPassword

      if (this.changingPassword) {
        this.changePasswordText = 'close password change'
      } else {
        this.changePasswordText = 'change password'
      }
    },
    deleteAccount () {
      this.request('delete', '/vendors/signups/' + this.accountID + '/delete/').then(response => {
        this.$emit('save')
      })
    },
    done () {
      this.$emit('done')
    },
    addVendor (vendor) {
      let isPresent = false
      for (let i = 0; i < this.pushVendors.length; i++) {
        if (vendor.id === this.pushVendors[i].id) {
          isPresent = true
        }
      }
      if (isPresent === false) {
        this.pushVendors.push(vendor)
      }
      this.searchedVendors = []
    },
    checkTest () {
      this.approval = !this.approval
      console.log(this.approval)
    },
    saveVendors () {
      this.vendorIDs = []

      for (var i = 0; i < this.pushVendors.length; i++) {
        this.vendorIDs.push(this.pushVendors[i].id)
      }

      if (this.$store.state.shop.myshopify_domain === 'andagain-nz.myshopify.com' && this.vendorIDs.length === 0) {
        this.accountError = 'No vendors selected.'

        return true
      }

      this.request('post', '/vendors/shop-vendor-accounts/', {
        vendor_signups: [{
          id: parseInt(this.id),
          vendor_ids: this.vendorIDs
        }],
        approved: this.approval
      }).then(response => {
        if (this.changingPassword) {
          let newPasswordElement = document.getElementById('new-password')
          let confirmNewPasswordElement = document.getElementById('confirm-new-password')

          newPasswordElement.style.borderColor = 'transparent'
          confirmNewPasswordElement.style.borderColor = 'transparent'

          if (newPasswordElement.value.length === 0) {
            newPasswordElement.style.borderColor = '#cc4b37'
          }

          if (confirmNewPasswordElement.value.length === 0) {
            confirmNewPasswordElement.style.borderColor = '#cc4b37'
          }

          if (newPasswordElement.value.length === 0 || confirmNewPasswordElement.value.length === 0) {
            this.passwordError = 'Please fill out all fields.'

            return true
          }

          if (newPasswordElement.value !== confirmNewPasswordElement.value) {
            this.passwordError = 'New and confirm passwords do not match.'

            return true
          }

          this.passwordSuccess = null
          this.passwordError = null

          this.request('put', '/accounts/change-password/', {
            old_password: 'alsdhuflIUhdlhaw1h2l3h1o23789qw8d',
            new_password1: newPasswordElement.value,
            new_password2: confirmNewPasswordElement.value,
            id: this.accountID
          }).then((response) => {
            this.passwordSuccess = 'Password has been updated'
          }).catch(error => {
            if (error) {
              this.passwordError = 'New password is not valid.'
            }
          })

          newPasswordElement.value = ''
          confirmNewPasswordElement.value = ''
        } else {
          this.$emit('save')
        }
      })
    },
    searchVendors (value) {
      if (value.length >= 2 && !this.searchingVendors) {
        this.searchingVendors = true

        this.request('get', '/vendors/commission-totals/', {
          search: value,
          ordering: 'name'
        }).then(response => {
          let items = response.results
          this.searchedVendors = []

          for (let i = 0; i < items.length; i++) {
            this.searchedVendors.push({
              id: items[i].id,
              name: items[i].name
            })
          }
          this.searchingVendors = false
        })
      }
    },
    removeVendor (vendorId) {
      for (var i = 0; i < this.pushVendors.length; i++) {
        if (this.pushVendors[i].id === vendorId) {
          this.pushVendors.splice(i, 1)
        }
      }
    }
  },
  created () {
    for (let i = 0; i < this.accountVendorList.length; i++) {
      this.pushVendors.push(this.accountVendorList[i])
    }

    this.id = this.accountID

    this.approval = this.accountApproval
  }

}

</script>

<style lang="scss" scoped>
@import "../styles/mixins";
@import "../styles/variables";

.remove {
  margin-left: 5px;
  margin-bottom: 5px;
}

.search {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/globals/editAccounts.vue